import {Component, OnInit} from '@angular/core';
import {onSideNavChange, animateText} from '../animations/animations';
import {CardStoreService} from '../shared/card-store.service';
import {UserValidation} from '../shared/user-validation';
import {Observable} from 'rxjs';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {CardWeb} from '../shared/card-web';
import {GameDesign} from '../design-recommender/shared/game-design';
import {MessageFactoryService} from '../shared/message-factory.service';
import {CardWebService} from '../shared/card-web.service';
import {ObjectExtractingServiceService} from '../shared/object-extracting-service.service';

interface Page {
  link: string;
  name: string;
  icon: string;
}

@Component({
  selector: 'em-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.css'],
  animations: [onSideNavChange, animateText]
})
/**
 * The left menu provides access to all use cases.
 *
 * Use cases are
 * - Exploration of unlocked misfit carddeck with problem/solution description
 * - Exploration of unlocked pattern carddeck with obstacles descriptions
 *
 * Subscribes itself to the UserLoginListener via the CardStoreService to
 * show in the menu the links to the unlocked carddecks and functions.
 */
export class LeftMenuComponent implements OnInit {

  public sideNavState = true;
  public linkText = true;
  userValidation$: Observable<UserValidation>;
  cardWebs: { userid: string, cardWeb: CardWeb, gameDesign: GameDesign }[];

isAuthenticated: boolean;
  public pages: Page[] = [
    {name: 'Designs', link: 'home', icon: 'grid_view'}
  ];

  constructor(
    private cs: CardStoreService,
    private mfs: MessageFactoryService,
    private oes: ObjectExtractingServiceService,
    private cws: CardWebService,
    private oidcSecurityService: OidcSecurityService) {
    this.oidcSecurityService.checkAuth().subscribe(({isAuthenticated, userData, accessToken}) => {
      this.isAuthenticated = isAuthenticated;
    });
  }

  ngOnInit(): void {
    this.cs.getUserLoginListener().subscribe(b => {
      this.userValidation$ = b;
    });
  }

  logout(): void {
    // CALL WEBSOCKET CONNECTION
    if (this.mfs.isInitialized()) {
      const messageObject = this.mfs.createMessageLeaveDesign();
      this.oes.handleAction(messageObject);
    }

    // OIDC-Logout;
    this.oidcSecurityService.logoffAndRevokeTokens()
      .subscribe((result) => console.log(result));
    console.log(':::::::::::' + this.isAuthenticated);
    // Traditional LogoutMethods
    this.cs.clearUserValidation();
    this.cs.clearUserData();
  }
}
